import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";

// Visible segmented language control (Svenska / English / Shqip). Persists via i18next (arcquan_lang).
export function InlineLanguageSelector({ testId = "language-selector", className = "" }) {
  const { t, i18n } = useTranslation();
  return (
    <div className={`flex items-center justify-center gap-1 self-center rounded-full border border-border bg-background/60 p-1 ${className}`}
      role="group" aria-label={t("common.language")} data-testid={testId}>
      {LANGUAGES.map((l) => {
        const active = l.code === i18n.resolvedLanguage;
        return (
          <button key={l.code} type="button" onClick={() => i18n.changeLanguage(l.code)} aria-pressed={active}
            data-testid={`${testId}-${l.code}`}
            className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>
            {l.flag} {l.label}
          </button>
        );
      })}
    </div>
  );
}
